export default __webpack_public_path__ + "static/media/PlantsForDinner_05.e24ae6ed.png";